import React from 'react'

export const ViewPayrollConfigRow = (props) => {
    const { leftLabel, leftValue, leftValueClassName, rightLabel, rightValue, rightValueClassName } = props;
    
    return (
        <div className="flex gap-6">
            <div className="flex flex-col gap-6 w-3/5">
                <div>
                    <div className='text-[#718096] word-wrap-break capitalize'>{leftLabel}</div>
                    <div className={`word-wrap-break ${leftValueClassName}`}>{leftValue}</div>
                </div>
            </div>
            <div className="flex flex-col gap-6 w-2/5">
                <div>
                    <div className='text-[#718096] word-wrap-break capitalize'>{rightLabel}</div>
                    <div className={`capitalize word-wrap-break ${rightValueClassName}`}>{rightValue}</div>
                </div>
            </div>
        </div>
    )
}